export const module = {
  info: {
    name: 'jikatel-vendor',
    caption: 'Jikatel Vendor'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Vendor',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-vendor',
    children: [
      {
        caption: 'Create Vendor',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-vendor->create'
      },
      {
        caption: 'List Vendors',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-vendor->list'
      }
    ]
  }
}

export default module
